import { getFormattedDate } from "./date";

// Utility function for filtering custom table date column value
export const dateFilter = (row, id, filterValue) => {
  if (!filterValue) return true;

  const rowValue = getFormattedDate(row.getValue(id));
  const filterDate = getFormattedDate(filterValue);

  return rowValue === filterDate;
};

export const textFilter = (row, id, filterValue) => {
  const cellValue = row.getValue(id) || "";
  return cellValue.toString().toLowerCase().includes(filterValue.toLowerCase());
};

export const booleanFilter = (row, id, filterValue) => {
  const cellValue = row.getValue(id);

  return cellValue?.toString() === filterValue;
};
